"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asset = exports.AssetRentingLogEntry = exports.AssetServiceLogEntry = void 0;
const to_js_date_1 = __importDefault(require("to-js-date"));
const firebase_1 = require("../../bindings/firebase");
class AssetServiceLogEntry {
    constructor(data) {
        this.comment = data.comment;
        this.created = data.created;
        this.created_by = data.created_by;
        this.finished_by = data.finished_by;
        this.title = data.title;
        this.condition = data.condition;
        this.date_in = data.date_in;
        this.price = data.price;
        this.performed_by = data.performed_by;
        this.completed = data.completed;
    }
    static async create(asset, by, comment, title, condition, price, performed_by, date) {
        var _a;
        const temp = {
            created_by: by,
            comment,
            created: date || new Date(),
            title,
            condition,
            price,
            performed_by,
            completed: false,
        };
        const assetRef = (_a = asset.querySnap()) === null || _a === void 0 ? void 0 : _a.ref;
        if (!assetRef) {
            throw Error('Asset is missing reference');
        }
        const newRef = await assetRef.collection('service_log').add(temp);
        const snapShot = await newRef.get();
        await assetRef.update({ service_active: true });
        return this.fromQueryDocumentSnapshot(snapShot);
    }
    static new(data) {
        return new this(data);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            return undefined;
        }
        const asset = this.new(snapshot.data());
        asset._querySnap = snapshot;
        asset._ref = snapshot.ref;
        asset._parentId = snapshot.ref.parent.parent.id;
        return asset;
    }
    static fromQuerySnapshot(snapshot) {
        const assetServiceLogEntries = [];
        if (!snapshot || !snapshot.docs || snapshot.empty) {
            return assetServiceLogEntries;
        }
        for (const d of snapshot.docs) {
            const assetServiceLogEntry = this.fromQueryDocumentSnapshot(d);
            if (assetServiceLogEntry) {
                assetServiceLogEntries.push(assetServiceLogEntry);
            }
        }
        return assetServiceLogEntries;
    }
    getCreatedDate() {
        return (0, to_js_date_1.default)(this.created);
    }
    getInDate() {
        if (!this.date_in) {
            return undefined;
        }
        return (0, to_js_date_1.default)(this.date_in);
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error('Somehow querysnap does not exist! asset');
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error('Somehow ref does not exist! asset');
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error('Somehow id does not exist! asset');
        }
        return qs.id;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error('Somehow parentid does not exist! asset');
        }
        return this._parentId;
    }
}
exports.AssetServiceLogEntry = AssetServiceLogEntry;
class AssetRentingLogEntry {
    constructor(data) {
        this.comment = data.comment;
        this.completed = data.completed;
        this.date_in = data.date_in;
        this.date_out = data.date_out;
        this.person = data.person;
        this.registered_in = data.registered_in;
        this.registered_out = data.registered_out;
    }
    static async create(asset, person, comment, by, date) {
        var _a;
        const temp = {
            person,
            comment,
            date_out: date || new Date(),
            completed: false,
        };
        if (by) {
            temp.registered_out = by;
        }
        const assetRef = (_a = asset.querySnap()) === null || _a === void 0 ? void 0 : _a.ref;
        if (!assetRef) {
            throw Error('Asset is missing reference');
        }
        const newRef = await assetRef.collection('renting_log').add(temp);
        const snapShot = await newRef.get();
        return this.fromQueryDocumentSnapshot(snapShot);
    }
    static new(data) {
        return new this(data);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            return undefined;
        }
        const asset = this.new(snapshot.data());
        asset._querySnap = snapshot;
        asset._ref = snapshot.ref;
        asset._parentId = snapshot.ref.parent.parent.id;
        return asset;
    }
    static fromQuerySnapshot(snapshot) {
        const assetRentingLogEntries = [];
        if (!snapshot || !snapshot.docs || snapshot.empty) {
            return assetRentingLogEntries;
        }
        for (const d of snapshot.docs) {
            const assetRentingLogEntry = this.fromQueryDocumentSnapshot(d);
            if (assetRentingLogEntry) {
                assetRentingLogEntries.push(assetRentingLogEntry);
            }
        }
        return assetRentingLogEntries;
    }
    getDateIn() {
        return (0, to_js_date_1.default)(this.date_in);
    }
    getDateOut() {
        return (0, to_js_date_1.default)(this.date_out);
    }
    setDateIn(newDate) {
        this.date_in = newDate;
    }
    setDateOut(newDate) {
        this.date_out = newDate;
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error('Somehow querysnap does not exist! asset');
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error('Somehow ref does not exist! asset');
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error('Somehow id does not exist! asset');
        }
        return qs.id;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error('Somehow parentid does not exist! asset');
        }
        return this._parentId;
    }
}
exports.AssetRentingLogEntry = AssetRentingLogEntry;
class Asset {
    constructor(data) {
        this.service_active = false;
        this.title = data.title;
        this.make = data.make;
        this.model = data.model;
        this.serial_number = data.serial_number;
        this.description = data.description;
        this.technical_description = data.technical_description;
        this.value = data.value;
        this.value_currency = data.value_currency;
        this.purchase_price = data.purchase_price;
        this.purchase_date = data.purchase_date;
        this.condemned_date = data.condemned_date;
        this.privately_owned = data.privately_owned;
        this.privately_owned_by = data.privately_owned_by;
        this.lent_to = data.lent_to;
        this.deleted = data.deleted;
        this.deleted_date = data.deleted_date;
        this.deleted_by = data.deleted_by;
        this.pictures = data.pictures;
        this.deleted_comment = data.deleted_comment;
        this.lent_out = data.lent_out;
        this.qr = data.qr;
        this.category = data.category;
        this.type = data.type;
        this.subtype = data.subtype;
        this.storage_facility = data.storage_facility;
        this.condition = data.condition;
        if (data.service_active) {
            this.service_active = data.service_active;
        }
    }
    static new(data) {
        const assetData = {
            category: undefined,
            condition: undefined,
            lent_to: undefined,
            deleted: false,
            qr: '',
            storage_facility: undefined,
            subtype: undefined,
            type: undefined,
            description: '',
            lent_out: false,
            make: '',
            model: '',
            privately_owned: false,
            privately_owned_by: '',
            purchase_date: new Date(1900, 0, 1),
            condemned_date: null,
            purchase_price: 0,
            serial_number: '',
            technical_description: '',
            title: '',
            value: 0,
            value_currency: 'NOK',
            service_active: false,
        };
        if (data) {
            Object.keys(data).forEach((key) => {
                // already have checks that key is in both
                assetData[key] = data[key];
            });
        }
        return new this(assetData);
    }
    static async fromFirebase(org_id, asset_id) {
        const snapshot = await (0, firebase_1.fs)()
            .collection('organizations')
            .doc(org_id)
            .collection('assets')
            .doc('data')
            .collection('items')
            .doc(asset_id)
            .get();
        return this.fromQueryDocumentSnapshot(snapshot);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            throw new Error('Person snapshot does not exist.');
        }
        const asset = this.new(snapshot.data());
        asset._querySnap = snapshot;
        asset._ref = snapshot.ref;
        asset._parentId = snapshot.ref.parent.parent.id;
        return asset;
    }
    static fromQuerySnapshot(snapshot) {
        const assets = [];
        if (snapshot.empty) {
            return assets;
        }
        for (const d of snapshot.docs) {
            const asset = this.fromQueryDocumentSnapshot(d);
            if (asset) {
                assets.push(asset);
            }
        }
        return assets;
    }
    getPurchaseDate() {
        return (0, to_js_date_1.default)(this.purchase_date);
    }
    getDeletedDate() {
        return (0, to_js_date_1.default)(this.deleted_date);
    }
    setPurchaseDate(newDate) {
        this.purchase_date = newDate;
    }
    setCondemnedDate(newDate) {
        this.condemned_date = newDate;
    }
    getCondemnedDate() {
        if (!this.condemned_date) {
            return undefined;
        }
        return (0, to_js_date_1.default)(this.condemned_date);
    }
    async getRentingLog(active) {
        const rentingLogSnapshot = await this.querySnap()
            .ref.collection('renting_log')
            .where('completed', '==', !active)
            .orderBy('date_out', 'desc')
            .get();
        return AssetRentingLogEntry.fromQuerySnapshot(rentingLogSnapshot);
    }
    async getServiceLog(active = true) {
        const serviceLogSnapshot = await this.querySnap()
            .ref.collection('service_log')
            .where('completed', '==', !active)
            .orderBy('created', 'desc')
            .get();
        return AssetServiceLogEntry.fromQuerySnapshot(serviceLogSnapshot);
    }
    async setRented(assetRentingLogEntry) {
        if (!this.querySnap()) {
            throw Error('Asset is not in database');
        }
        if (!assetRentingLogEntry || assetRentingLogEntry.completed) {
            this.lent_out = false;
            this.lent_to = undefined;
            await this.querySnap().ref.update({
                lent_out: false,
                lent_to: null,
            });
            return;
        }
        this.lent_out = true;
        this.lent_to = assetRentingLogEntry.person;
        await this.querySnap().ref.update({
            lent_out: true,
            lent_to: assetRentingLogEntry.person,
        });
    }
    async setDeleted(deleted_by, deleted_comment, deleted_date) {
        if (!this.querySnap()) {
            throw Error('Asset is not in database');
        }
        this.deleted_by = deleted_by;
        this.deleted_comment = deleted_comment;
        this.deleted = true;
        this.deleted_date = deleted_date;
        await this.querySnap().ref.update({
            deleted_by,
            deleted_comment,
            deleted: true,
            deleted_date,
        });
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error('Somehow querysnap does not exist! asset');
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error('Somehow ref does not exist! asset');
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error('Somehow id does not exist! asset');
        }
        return qs.id;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error('Somehow parentid does not exist! asset');
        }
        return this._parentId;
    }
}
exports.Asset = Asset;
//# sourceMappingURL=assets.js.map